/**
 * /packages/:id — onboarding package home (detail) route.
 *
 * This is the "package home" — the entry framing for everything inside a
 * package (batches, ingestion, status). It is NOT a settings page.
 *
 * Gated behind VITE_ENABLE_PACKAGE_HOME. When flag is off, redirects to /.
 */

import { useParams, Navigate } from 'react-router-dom'
import { PackageHomeShell } from '../features/packages/package-home-shell'

const PACKAGE_HOME_ENABLED = import.meta.env.VITE_ENABLE_PACKAGE_HOME === 'true'

export function PackageDetailPage() {
  const { id } = useParams<{ id: string }>()

  if (!PACKAGE_HOME_ENABLED) {
    return <Navigate to="/" replace />
  }

  if (!id) {
    return <Navigate to="/packages" replace />
  }

  return <PackageHomeShell packageId={id} />
}
